import React from 'react';
import { useTranslation } from 'react-i18next';
import './MaintenanceScreen.css';

interface MaintenanceScreenProps {
  message?: string;
}

const MaintenanceScreen: React.FC<MaintenanceScreenProps> = ({ message }) => {
  const { t } = useTranslation();

  const handleTelegram = () => {
    window.open('https://t.me/safepermoon', '_blank');
  };

  return (
    <div className="maintenance-screen">
      <div className="maintenance-container">
        <div className="maintenance-icon">🛠️</div>

        <h1 className="maintenance-title">{t('maintenance.title')}</h1>

        <div className="maintenance-message">
          <p>{message || t('maintenance.message')}</p>
        </div>

        <div className="maintenance-animation">
          <div className="gear gear-1">⚙️</div>
          <div className="gear gear-2">⚙️</div>
          <div className="gear gear-3">⚙️</div>
        </div>

        <div className="maintenance-actions">
          <button className="telegram-button" onClick={handleTelegram}>
            📢 {t('maintenance.followUpdates')}
          </button>
        </div>

        <div className="maintenance-footer">
          <p>{t('maintenance.temporarilyUnavailable')}</p>
          <p className="maintenance-eta">{t('maintenance.comingSoon')} 🚀</p>
        </div>
      </div>
    </div>
  );
};

export default MaintenanceScreen;
